/* eslint-disable */
// @ts-nocheck

import { ChevronDown, Tag } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { cn } from '@/lib/utils'

import { StatusOption } from '../constants/statusOptions'

interface SelectFilterProps {
  title: string
  placeholder?: string
  selectionOptions: StatusOption[]
  activeSelections: string[]
  onSelectionsChange: (statuses: string[]) => void
  searchActive?: boolean
  icon?: React.ReactNode
  className?: string
}

export const SelectFilter = ({
  selectionOptions,
  activeSelections,
  onSelectionsChange,
  title,
  placeholder = 'Buscar estado...',
  searchActive = true,
  icon,
  className,
}: SelectFilterProps) => {
  const toggleStatus = (value: string) => {
    // Para contenedores, solo permitir una selección
    onSelectionsChange([value])
  }

  const getActiveCount = () => {
    if (activeSelections.includes('all')) return 0
    return activeSelections.length
  }

  const activeCount = getActiveCount()

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          aria-label={title}
          className={cn('gap-1.5', className)}
          variant="outline"
        >
          {icon ? icon : <Tag className="h-4 w-4" />}
          <span>{title}</span>
          <ChevronDown className="h-4 w-4 opacity-50" />
          {activeCount > 0 && (
            <Badge className="ml-1 rounded-full px-1.5" variant="secondary">
              {activeCount}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[200px] p-0">
        <Command>
          {searchActive && <CommandInput placeholder={placeholder} />}
          <CommandList>
            <CommandEmpty>No se encontraron resultados.</CommandEmpty>
            <CommandGroup>
              {selectionOptions.map((status) => (
                <CommandItem
                  className="flex cursor-pointer items-center gap-2"
                  key={status.value}
                  onSelect={() => toggleStatus(status.value)}
                >
                  <div className="flex flex-1 items-center gap-2">
                    <Checkbox
                      checked={activeSelections.includes(status.value)}
                      onCheckedChange={() => toggleStatus(status.value)}
                    />
                    <span>{status.label}</span>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
